import { Button, Center, Paper, Stack, Text, Title } from '@mantine/core'
import { useAdminAuth } from '../auth/AdminAuthProvider'

export default function SignIn() {
  const { signIn } = useAdminAuth()
  return (
    <Center mih="100vh" p="md">
      <Paper withBorder p="xl" w={400} maw="100%">
        <Stack gap="xs">
          <Text size="xs" c="dimmed" tt="uppercase" fw={600} style={{ letterSpacing: '0.08em' }}>
            RaceDash
          </Text>
          <Title order={1} size="h3">
            Admin
          </Title>
          <Text c="dimmed" size="sm">
            Platform administration. Signing in here is separate from the main app — sessions are
            scoped to this origin and are not shared.
          </Text>
          <Button fullWidth mt="md" onClick={() => void signIn()}>
            Continue with Google
          </Button>
        </Stack>
      </Paper>
    </Center>
  )
}
